import {
  VEHICLE_UPDATE_REQUEST, VEHICLE_UPDATE_SUCCESS, VEHICLE_UPDATE_ERROR,
  VEHICLE_CREATE_BY_FASECOLDA_REQUEST, VEHICLE_CREATE_BY_FASECOLDA_SUCCESS, VEHICLE_CREATE_BY_FASECOLDA_ERROR,
  VEHICLE_CREATE_BY_PLATE_REQUEST, VEHICLE_CREATE_BY_PLATE_SUCCESS, VEHICLE_CREATE_BY_PLATE_ERROR,
  VEHICLE_CREATE_REQUEST, VEHICLE_CREATE_SUCCESS, VEHICLE_CREATE_ERROR, VEHICLE_CREATE_BY_REFERENCE_REQUEST,
  VEHICLE_CREATE_BY_REFERENCE_SUCCESS,
  VEHICLE_CREATE_BY_REFERENCE_ERROR,
  GLOBAL_QUOTATION_RESET_STATE_VEHICLE,
} from 'Redux/types/globalQuotationTypes';


const initianState = {
  id: null,
  placa: null,
  codigo_fasecolda: null,
  modelo: null,
  marca: null,
  referencia: null,
  clase: null,
  valor_asegurado: null,
  valor_accesorios: null,
  ciudad_circulacion: null,
  ciudad_circulacion_name: null,
  is_new: false,
  has_plate: true,
  has_accesorios: false, // Indica si el vehículo tiene accesorios. Solo se maneja en el frontend
  servicio: 'Particular',
  is_utilitarian: null,

  valor_asegurado_updated: false, // Para saber si ya se actualizó el valor asegurado, en los casos de que el vehículo sea nuevo :)

  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
    // updateFrom: null,
  },
  confirm: false,
};

// // PENDIENTE ELIMINAR!!! - Se hizo para el desarrollo de las comparaciones
// let fakeInitialState = {
//   ...initianState,

//   placa: 'ABC123',
//   marca: 'Renault',
//   referencia: 'Sandero',
//   modelo: 2020,
//   valor_asegurado: 21000130,

// };

// Se unifica en una función la extracción de los valores del vehículo creado o actualizado
const getJsonVehicleFromResponse = (response) => {
  const vehicleData = {
    id: response.data.id,
    placa: response.data.placa,
    codigo_fasecolda: response.data.codigo_fasecolda,
    modelo: response.data.modelo,
    marca: response.data.marca,
    referencia: response.data.referencia,
    clase: response.data.clase,
    valor_asegurado: parseFloat(response.data.valor_asegurado || 0),
    valor_accesorios: parseFloat(response.data.valor_accesorios || 0),
    ciudad_circulacion: response.data.ciudad_circulacion,
    ciudad_circulacion_name: response.data.ciudad_circulacion_name,
    is_new: response.data.is_new,
    has_plate: response.data.has_plate,
    servicio: response.data.servicio,
    is_utilitarian: response.data.is_utilitarian,
  };

  if (vehicleData.valor_accesorios > 0) vehicleData.has_accesorios = true;

  return vehicleData;
};

const vehicleReducer = (state = initianState, actions) => {
  switch (actions.type) {
    case VEHICLE_UPDATE_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
          message: null,
          statusCode: null,
        },
      });
    case VEHICLE_UPDATE_SUCCESS:
      return ({
        ...state,
        ...getJsonVehicleFromResponse(actions.response),

        valor_asegurado_updated: actions.valor_asegurado_updated,
        confirm: actions.confirm,

        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });

    case VEHICLE_UPDATE_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });


    // ------- ACTUALIZANDO MENDIANTE CODIGO FASECOLDA -----
    case VEHICLE_CREATE_BY_FASECOLDA_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
          message: null,
          statusCode: null,
        },
      });
    case VEHICLE_CREATE_BY_FASECOLDA_SUCCESS:
      return ({
        ...state,
        ...getJsonVehicleFromResponse(actions.response),

        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });
    case VEHICLE_CREATE_BY_FASECOLDA_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });

    // ------- ACTUALIZANDO MENDIANTE PLACA -----
    case VEHICLE_CREATE_BY_PLATE_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
          message: null,
          statusCode: null,
        },
      });
    case VEHICLE_CREATE_BY_PLATE_SUCCESS:
      return ({
        ...state,
        ...getJsonVehicleFromResponse({
          ...actions.response,
          data: {
            ...actions.response.data,
            ciudad_circulacion_name: null, // Para que siempre se pida independientemente de si ya se tiene saved
            ciudad_circulacion: null, // Para que siempre se pida independientemente de si ya se tiene saved
          },
        }),

        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions?.response?.status || 200,
        },
      });
    case VEHICLE_CREATE_BY_PLATE_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions?.response?.data?.message || 'Error consultando la información del vehículo',
          statusCode: actions?.response?.status || 500,
        },
      });


    // ------- CREANDO VEHICULO DESDE CERO -----
    case VEHICLE_CREATE_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
          message: null,
          statusCode: null,
        },
      });
    case VEHICLE_CREATE_SUCCESS:
      return ({
        ...state,
        ...getJsonVehicleFromResponse(actions.response),

        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });
    case VEHICLE_CREATE_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });

    case GLOBAL_QUOTATION_RESET_STATE_VEHICLE:
      return ({
        ...state,
        ...initianState,
        ...actions.defaults,
      });
    // ------- ACTUALIZANDO MENDIANTE REFERENCIA RETORNA VALOR Y CODE FASECOLDA -----
    case VEHICLE_CREATE_BY_REFERENCE_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
          message: null,
          statusCode: null,
        },
      });
    case VEHICLE_CREATE_BY_REFERENCE_SUCCESS:
      return ({
        ...state,
        ...getJsonVehicleFromResponse(actions.response),

        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });

    case VEHICLE_CREATE_BY_REFERENCE_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });

    default:
      return (state);
  }
};

export default vehicleReducer;
